module.exports = __webpack_public_path__ + "static/media/Winner3.0c8b7cf4.png";